import theme from 'assets/theme/theme';

const styles = () => ({
    basicCell: {
        paddingLeft: '5px',
        paddingRight: '5px'
    },
    header: {
        display: 'flex',
        margin: '10px 10px 5px 10px'
    },
    leftIcon: {
        fontSize: 20,
        marginRight: '4px'
    },
    loaderContainer: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        width: '100%'
    },
    nameCell: {
        alignItems: 'center',
        display: 'flex',
        paddingLeft: 0
    },
    openIcon: {
        fontSize: '15px',
        marginLeft: '5px',
        marginBottom: '2px',
    },
    paper: {
        height: 'calc(100% - 70px)',
        marginLeft: '10px',
        overflowX: 'auto',
        width: 'calc(100% - 20px)'
    },
    root: {
        height: '100%',
        overflow: 'auto',
        width: '100%'
    },
    searchBar: {
        margin: '0px 0px 0px 5px',
        width: 'calc(100% - 20px)'
    },
    searchIcon: {
        color: theme.palette.common.grey
    },
    table: {
        minWidth: 650
    },
    tableContainer: {
        height: 'calc(100% - 50px)',
        overflow: 'auto'
    },
    tableHeadCell: {
        backgroundColor: theme.palette.white.main,
        paddingLeft: '5px',
        paddingRight: '5px'
    },
    urlCell: {
        maxWidth: '150px',
        overflow: 'hidden',
        paddingLeft: '5px',
        paddingRight: '5px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    urlContainer: {
        display: 'flex',
        alignItems: 'center'
    }
});

export default styles;
